import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/creators/{creatorId}/case-document-form-requests']['GET'];

type Input = ThisApi['params'] & ThisApi['query'];
type Output = ThisApi['response'];

const getCaseDocumentFormRequests = async ({ creatorId, page, perPage }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/creators/{creatorId}/case-document-form-requests', { creatorId });
  const data = await noodleApiClient.get(path, { params: { page, perPage } });
  return data.data;
};

export default getCaseDocumentFormRequests;
